export default __webpack_public_path__ + "static/media/img3.fa81ca90.jpg";